import axiosInstance from "./axiosInstance";

export const getOrderCooldown = async () => {
  const accessToken = localStorage.getItem("accessTokenGC");
  try {
    const { data } = await axiosInstance.get("/api/order/cooldown", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return data;
  } catch (error) {
    throw new Error("Error fetching order cooldown.");
  }
};
